import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PHONE_TEL, WHATSAPP_URL } from "@/lib/site";

export const FinalCta = ({ onBook }) => (
  <section data-testid="final-cta-section" className="px-5 pb-28 md:px-8 md:pb-36">
    <Reveal>
      <div className="gold-glow relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border border-gold/25 bg-[#0c0c0c] px-6 py-20 text-center md:py-28">
        <div
          className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[36rem] -translate-x-1/2 rounded-full bg-gold/10 blur-[100px]"
          aria-hidden
        />
        <span className="relative text-xs font-bold uppercase tracking-[0.3em] text-gold">
          One inspection can save you lakhs
        </span>
        <h2 className="relative mx-auto mt-6 max-w-3xl font-heading text-5xl font-extrabold tracking-tighter text-white md:text-7xl">
          Don't Buy <span className="text-gold">Blind.</span>
        </h2>
        <p className="relative mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
          Book a professional inspection today and avoid costly repairs
          tomorrow.
        </p>
        <div className="relative mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="final-book-inspection-btn"
            onClick={onBook}
            className="group flex items-center gap-3 rounded-full bg-gold px-8 py-4 font-heading text-base font-extrabold text-black transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-gold-light hover:shadow-[0_16px_40px_-12px_rgba(212,175,55,0.5)]"
          >
            Book Inspection
            <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            data-testid="final-call-btn"
            href={PHONE_TEL}
            className="glass-chip flex items-center gap-3 rounded-full px-8 py-4 font-heading text-base font-bold text-white transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-gold/50"
          >
            <Phone className="h-5 w-5 text-gold" />
            Call Now
          </a>
          <a
            data-testid="final-whatsapp-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-full border border-white/15 px-8 py-4 font-heading text-base font-bold text-white/80 transition-[border-color,color,transform] duration-300 hover:-translate-y-1 hover:border-[#25D366]/60 hover:text-[#25D366]"
          >
            <MessageCircle className="h-5 w-5" />
            WhatsApp
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
